export const ROUTE_CODE_MAPPING = {
  AIR: 'Airport link bus',
  CTY: 'City link bus',
  INN: 'Inner link bus',
  OUT: 'Outer link bus',
  MEX: "Mahu city express bus",
  NEX: 'Northern express bus',
  NX1: 'Northern express one bus',
  NX2: 'Northern express two bus',
  RBE: "Rail Bus Eastern Line",
  RBEX: "Rail Bus Eastern Express",
  RBGX: "Rail Bus Glen Innes Express",
  RBO: "Rail Bus Onehunga Line",
  RBOX: "Rail Bus Onehunga Express",
  RBOC: "Rail Bus Onehunga Connector",
  RBPX: "Rail Bus Panmure Express",
  RBS: "Rail Bus Southern Line",
  RBSX: "Rail Bus Southern Express",
  RBW: "Rail Bus Western Line",
  RBWX: "Rail Bus Western Express",
  SKY: 'Sky bus',
  TMK: 'Tamaki link bus',

  EAST: 'Eastern train line',
  HUIA: 'Te Huia train',
  ONE: 'Onehunga train line',
  PUK: 'Pukekohe connection',
  STH: 'Southern train line',
  WEST: 'Western train line',

  BAYS: 'Bayswater ferry',
  BIRK: 'Birkenhead ferry',
  CORO: 'Coromandel ferry',
  DEV: 'Devonport ferry',
  GULF: 'Gulf Harbour ferry',
  HMB: 'Half Moon Bay ferry',
  HOBS: 'Hobsonville, Beach Haven ferry',
  MTIA: 'Waiheke ferry',
  PINE: 'Pine Harbour ferry',
  RAK: 'Rakino Island ferry',
  RANG: 'Rangitoto Island ferry',
  SBAY: 'Stanley Bay ferry',
  TIRI: 'Tiritiri Island ferry',
  WSTH: 'West Harbour ferry',
};
